"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const components_common_autocomplete_1 = require("@hotelplan/components.common.autocomplete");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const TravelDestinationLabelCaption_1 = __importDefault(require("./TravelDestinationLabelCaption"));
const TravelDestionation_utils_1 = require("./TravelDestionation.utils");
const TravelDestinationLabel = props => {
    const renderCaption = (0, react_1.useCallback)(() => {
        return react_1.default.createElement(TravelDestinationLabelCaption_1.default, { item: props.item });
    }, [props.item]);
    return (react_1.default.createElement(components_common_autocomplete_1.AutocompleteOption, { icon: react_1.default.createElement(components_common_icon_1.Icon, { name: (0, TravelDestionation_utils_1.getIconNameForItem)(props.item) }), label: props.label, renderCaption: renderCaption }));
};
exports.default = TravelDestinationLabel;
//# sourceMappingURL=TravelDestinationLabel.js.map